var App = App || {};

App.ZagScrollAnimations = (function () {
    'use strict';

    function init() {
        if (!App.ZagScrollAnimate || typeof App.ZagScrollAnimate.initialize !== 'function') {
            return;
        }

        App.ZagScrollAnimate.initialize('.hero', {
            offset: 75,
            overflow: true,
            targets: [
                { selector: '.hero-image', type: 'animate__fadeInUp', stagger: 0 },
                { selector: '.hero-quick-links .hero-quick-link-card', type: 'animate__fadeInUp', stagger: 100 }
            ]
        });

        App.ZagScrollAnimate.initialize('.promos-selector-component', {
            offset: 75,
            targets: [
                { selector: '.promos-selector-component__carousel.splide .splide__track', type: 'animate__fadeInUp', stagger: 0 }
            ]
        });

        App.ZagScrollAnimate.initialize('.block-callout-promo', {
            offset: 75,
            targets: [
                { selector: '.block-callout-promo__layout', type: 'animate__fadeInUp', stagger: 0 }
            ]
        });

        App.ZagScrollAnimate.initialize('.block-community-involvement', {
            offset: 75,
            targets: [
                { selector: '.block-community-involvement__features', type: 'animate__fadeInUp', stagger: 0 },
                { selector: '.block-community-involvement__cta-section', type: 'animate__fadeInUp', stagger: 0 }
            ]
        });

        App.ZagScrollAnimate.initialize('.block-resources', {
            offset: 75,
            targets: [
                { selector: '.block-resources__cards .block-resources__card-item', type: 'animate__fadeInUp', stagger: 100 },
                { selector: '.block-resources__bottom-section', type: 'animate__fadeInUp', stagger: 0 }
            ]
        });

        App.ZagScrollAnimate.initialize('.block-rates-band', {
            offset: 75,
            targets: [
                { selector: '.rates-band__cards-wrapper .rates-band__card', type: 'animate__fadeInUp', stagger: 300 }
            ]
        });
    }

    return {
        init: init
    };
})();

document.addEventListener('DOMContentLoaded', function () {
    App.ZagScrollAnimations.init();
});
